import { ReactNode, useEffect } from 'react';

import { useTelegramExpandOnMount } from '@app/shared/hooks/useTelegramExpandOnMount';
import { configureTelegramWebApp } from '@app/shared/utils/common';

interface TelegramProviderProps {
  children: ReactNode;
}

export function TelegramProvider({ children }: TelegramProviderProps) {
  useEffect(() => {
    configureTelegramWebApp();
  }, []);

  useTelegramExpandOnMount();

  return children;
}
